import { IProdutoRow } from "pages/registra-venda/registra-venda.model";
import { roundHalfToEven } from "utils/util";

export const getQuantidadeItensBrinde = (itens: Array<IProdutoRow>): number =>
    itens.filter(item => item.brinde).reduce((total, item) => total + item.quantidade, 0);

export const getValorTotalItensSemDesconto = (itens: Array<IProdutoRow>, somarValorBrindeTotalNota: boolean): number =>
    itens
        .filter(item => somarValorBrindeTotalNota || !item.brinde)
        .reduce((total, item) => total + (item.quantidade * item.produto.preco), 0);

export const getValorTotalItensComDesconto = (itens: Array<IProdutoRow>, somarValorBrindeTotalNota: boolean): number => {
    const valorTotal = itens
        .filter(item => somarValorBrindeTotalNota || !item.brinde)
        .reduce((total, item) => total + (item.quantidade * item.produto.preco - item.itemDesconto.valorDesconto), 0);
    return roundHalfToEven(valorTotal, 2);
};
